import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

// eslint-disable-next-line
import style from './_style.css';

class Index extends Component {
    render() {
        const { intl, text, button } = this.props;
        return (
            <div className="label_row bg_golden_yellow">
                <div className="label_content">
                    <Typography component="p" className="barlow_regular_message c_white">
                        {intl.formatMessage({ id: text })}
                    </Typography>
                </div>
                <Button className="barlow_semibold_button c_white" onClick={this.props.onClick}>
                    {intl.formatMessage({ id: button })}
                </Button>
            </div>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

Index = injectIntl(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/labels/LabelWarning.js